import { actionCreatorFactory } from "typescript-fsa";
import {NewUser} from '../typing/generalType';

const actionCreator = actionCreatorFactory("USERINPUT");

const createUser = actionCreator<{NewUser:NewUser}>("USERINPUT_CREATEUSER");
const showQrCode = actionCreator<{token:string}>("USERINPUT_QRCode");
// state update action object
export const actions = {createUser,showQrCode};